/* eslint-disable react/jsx-filename-extension */
import * as React from 'react';
import { Grid } from 'semantic-grab-ui/src';
import { nodeTypes, targetUserTypes } from 'data/trident-types';
import * as _ from 'lodash';
import './WidgetComponent.scss';
import { getNodeTypeChildOptions, preOrderTraversalFromCurrentNodeToItsChildren } from './util';
import { CampaignWidgetProps } from 'types/ts/campaigns';

import SubScenarioWidget from 'components/form/trident-campaigns/SubScenarioWidget';
import AddNodeDropdown from './AddNodeDropdown';
import { VARIABLE_NAME } from './constants/campaign';
import LimitHitWarning from 'components/form/trident-campaigns/LimitHitWarning';

export default class ScenarioWidget extends React.Component<CampaignWidgetProps> {
  render() {
    const { model, currentNodeKey, clickedNode } = this.props;

    const gridStyle = {
      width: 'auto',
    };
    const gridWithoutPadding = {
      paddingTop: '0rem',
      paddingBottom: '0rem',
    };

    const userType = _.get(model, 'targetUserType', targetUserTypes.pax);
    const subScenarios = _.get(model.nodes[currentNodeKey].data, 'scenarios', []);
    const noOfChildren = _.get(model.nodes[currentNodeKey], 'children', []).length;
    const hasExperimentChild = _.get(model.nodes[currentNodeKey], 'children', []).some(child => model.nodes[child] && model.nodes[child].type === 'experiment');
    const renderAddButton = noOfChildren === 0 && !hasExperimentChild;

    // check wheather flow is completed or not, it will help to render add button with set of options after flow completed.
    const flowCompleted = preOrderTraversalFromCurrentNodeToItsChildren(model, currentNodeKey, true);
    const addButtonAfterFlow = noOfChildren !== 0 && flowCompleted && !hasExperimentChild;
    // as per code we can have only two scenario in chain scenario case.

    // check whether lastOccurrence is enabled at scenario node or not
    let isLastOccurrence = false;
    if (_.get(model.nodes[currentNodeKey], 'recordLastOccurrenceKey')) isLastOccurrence = true;

    const showExperimentNodeDropdown = noOfChildren === 0 && (userType === targetUserTypes.pax || userType === targetUserTypes.mex || userType === targetUserTypes.dax);

    const limits = _.get(model, `nodes[${currentNodeKey}].limits`, []);
    const isUsingDynamicVariables = limits.some(x => !_.isEmpty(_.get(x, VARIABLE_NAME)));

    let childOptions = [];
    if (renderAddButton) {
      childOptions = ['actions', 'condition', 'delay', 'randomizer'];

      if (!isUsingDynamicVariables) {
        childOptions = [...childOptions, 'count'];
      }
    } else if (addButtonAfterFlow) {
      childOptions = ['condition', 'delay', 'randomizer'];
    }
    if (showExperimentNodeDropdown) {
      childOptions.push('experiment');
    }

    const allowedChildNodes = getNodeTypeChildOptions(model.targetUserType, nodeTypes.scenarios);
    if (!_.isEmpty(allowedChildNodes)) {
      childOptions = childOptions.filter(option => allowedChildNodes.includes(option));
    }

    return (
      <div>
        <div style={{ position: 'absolute', top: subScenarios.length <= 1 ? '0px' : '40px', right: subScenarios.length <= 1 ? '60px' : '35px', zIndex: 1000 }}>
          <LimitHitWarning
            content={'Total limit hit'}
            usage={_.get(model, `usage.scenarioUsages.${currentNodeKey}.total`)}
            limit={_.result(_.find(_.get(model, `nodes.${currentNodeKey}.limits`), (obj) => obj.per === 'total'), 'limit')}
          />
        </div>
        {subScenarios.length <= 1 &&
          <Grid>
            <Grid.Column style={gridStyle}>
              <SubScenarioWidget
                model={model}
                currentNodeKey={currentNodeKey}
                clickedNode={clickedNode}
                handleNodePreview={this.props.handleNodePreview}
                subScenarioIndex={0}
              />
              {isLastOccurrence &&
              <div className="lastTimeOccurrenceeSingleScenario">
                {_.get(model.nodes[currentNodeKey], 'recordLastOccurrenceKey')}
              </div>
              }
              {
                childOptions.length > 1 &&
                <AddNodeDropdown
                  choices={childOptions}
                  handleAddNode={this.props.handleAddNode}
                  currentNodeKey={currentNodeKey}
                  subScenarioIndex={1}
                />
              }
            </Grid.Column>
          </Grid>
        }


        {subScenarios.length > 1 && // chained scenario
          <div className="wrapScenarios">
            {
              _.map(subScenarios, (_, index) => {
                return (
                  <React.Fragment>
                    <Grid>
                      <SubScenarioWidget
                        model={model}
                        currentNodeKey={currentNodeKey}
                        clickedNode={clickedNode}
                        handleNodePreview={this.props.handleNodePreview}
                        subScenarioIndex={index}
                        isFirstSubScenario={index === 0}
                      />
                    </Grid>
                    {
                      index === Math.floor(subScenarios.length / 2) - 1 ? // to show add button in the middle
                  <Grid>
                    <Grid.Column style={gridWithoutPadding} textAlign="right">
                      {
                        childOptions.length > 1 &&
                            <AddNodeDropdown
                              choices={childOptions}
                              handleAddNode={this.props.handleAddNode}
                              currentNodeKey={currentNodeKey}
                              subScenarioIndex={subScenarios.length}
                            />
                      }
                    </Grid.Column>
                  </Grid>
                        :
                        <p className="subScenarioDivider" />
                    }
                  </React.Fragment>
                );
              })
            }

            {isLastOccurrence &&
              <div className="lastTimeOccurrencee">
                {_.get(model.nodes[currentNodeKey], 'recordLastOccurrenceKey')}
              </div>
            }
          </div>
        }
      </div>
    );
  }
}
